import type { JSONContent } from '@tiptap/core';

export const getIsTipTapData = (wysiwyg: JSONContent) => {
    return wysiwyg?.type === 'doc';
};
